import moment from "moment";
import React, { useEffect, useState, Component, useRef } from "react";
import { Col, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap";
import { connect, useDispatch, useSelector } from "react-redux";
import { bidBIcon, loaderIcon, new_image_thumbnail, sneakPeekBerry, sneakpreview, timetable } from "shared/images/images";
import { ItemsService, SalesService } from "shared/services";
import { isAuthorized, logout } from "shared/settings/auth";
import store from 'features/store';
import { MyAccountMenuList, ToggleSideBar, removeSideBar } from "../base/auth-pages/MyAccount/MyAccountMenuList";
import './auctionsp.scss';
import { addDataLayer } from "shared/utils/utils";
import { Helmet } from "react-helmet";
import { Loader } from "shared/hoc/loader/Loader";
import { eye } from "shared/assets/icons";
import PaginationBox from "../base/public/HOC/PaginationBox";
let pageSize = 5
function AuctionSneakPeekfn(props) {
    const naming = {
        "newlisting": "New Listing Preview",
        "bidderinterest": "Chosen For You",
        "uniqueitems": "Unique Treasure"
    }
    const statemaintenance = useSelector(state => state?.statemaintenance);
    const dispatch = useDispatch()
    const [pageLoading, setPageLoading] = useState(true);
    const [saleList, setSaleList] = useState([]);
    const [istodaySale, setistodaySale] = useState(false);
    const [itemList, setitemList] = useState([]);
    const [contentload, setcontentload] = useState(false);
    const [innerWidth, setInnerWidth] = useState(window.innerWidth);
    const [disableWatch, setDisableWatch] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const pagekey = useRef({
        total: null,
        next: null,
        previous: null
    })
    const currentindex = useRef(1)

    useEffect(() => {

        loading();
        dispatch({ type: 'SIDEBAR_MENU_LIST', payload: { menuList: MyAccountMenuList(), withSpan: false } });
        const handleResize = () => {
            setInnerWidth(window.innerWidth);
            ToggleSideBar()
        };

        let dataLayerData = {
            'event': 'auction_sneak_peek',
            'buyr_id': props.user.id
        }
        addDataLayer(dataLayerData);
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            removeSideBar()
        };
    }, []);

    const loading = async () => {
        await getItemList();
        let screenState = statemaintenance?.["AuctionSneakPeekSale"]
        if (screenState) {
            pagekey.current = screenState?.pagekey
            currentindex.current = screenState?.previousPage
            await getSaleList(screenState?.currentPage);
        } else {
            await getSaleList();
        }
        setPageLoading(false);
    }

    const getItemList = async () => {
        ItemsService.getPreviewItemsList().then(
            async (itemList) => {
                const temp = itemList.data.data;
                let data = Object.keys(temp)
                data = data.map((item) => {
                    return ({
                        ctype: item,
                        ...temp[item]
                    })
                })
                setitemList(data)
                await getWatchList(data)

            }
        ).catch((error) => {
            if (error?.status === 401) {
                store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                logout(props.history, false);
            }
        });
    }

    const getWatchList = async (itemLists) => {
        if (isAuthorized()) {
            let itemId = [];
            itemLists.forEach(item => {
                itemId.push(item.item_id);
            });
            if (itemLists.length > 0) {
                const data = {
                    "sort": [{ "field": "id", "direction": "desc" }],
                    "filter": [{ "field": "itemid", "value": [itemId], "op": "IN", "join": "AND" }],
                    "field": ["itemid"],
                    "page": { "size": itemLists.length + 1 }
                };
                await ItemsService.getWatchListItem(data).then(
                    response => {
                        const watch = response.data.data;
                        itemLists = itemLists.map((item) => {
                            return ({
                                ...item,
                                iswatch: watch.filter(i => i?.itemid === item?.item_id).length > 0
                            })
                        })
                        setitemList(itemLists)
                    }
                ).catch(error => {
                });
            }
        } else {
        }
    }
    const getSaleList = async (key = null) => {
        let newDate = moment().subtract(7, 'days').format("YYYY-MM-DD 00:00:00");
        let endDate = moment().add(7, 'days').format("YYYY-MM-DD 23:59:59");
        let payload = {
            "page": { 'size': pageSize },
            "sort": [{ "field": "starttime", "direction": "desc" }],
            "field": ["id", "title", "starttime", "endtime", "itemcount", "locationid", "locationtitle", "status", "timezoneid", "timezonename", "endtimeutc"],
            "filter": [
                { "field": "itemcount", "value": 1, "op": ">=", "join": "AND" },
                { "field": "starttime", "value": newDate, "op": ">=", "join": "AND" },
                { "field": "starttime", "value": endDate, "op": "<=", "join": "AND" },
            ]
        }

        delete payload["page"]["previous"]
        delete payload["page"]["next"]
        delete payload["page"]["total"]
        delete payload["page"]["from"]
        delete payload["page"]["to"]
        if (key != null) {
            if (key == currentindex.current + 1 && pagekey.current?.next != null) {
                payload["page"]["next"] = pagekey.current?.next
            } else if (key == currentindex.current - 1 && pagekey.current?.previous != null) {
                payload["page"]["previous"] = pagekey.current?.previous
            } else {
                payload["page"].total = pagekey.current?.total;
                payload["page"].from = currentindex.current;
                payload["page"].to = key;

                if (key > currentindex.current) {
                    payload["page"]["next"] = pagekey.current?.next
                } else {
                    payload["page"]["previous"] = pagekey.current?.previous
                }
            }
            let pusttoStore = { ...statemaintenance }
            pusttoStore["AuctionSneakPeekSale"] = {
                ...pusttoStore?.["AuctionSneakPeekSale"],
                currentPage: key == null ? 1 : key,
                pagekey: pagekey.current,
                previousPage: key == null ? 0 : currentindex.current

            }
            dispatch({
                type: 'PUSH_TO_STATE', payload: pusttoStore
            });
        }
       
        currentindex.current = key == null ? 1 : key
        await SalesService.getSneakPeekSaleList(payload).then(
            async (resp) => {
                pagekey.current = {
                    total: resp?.data?.page?.total ? resp?.data?.page?.total : pagekey.current.total ? pagekey.current.total : null,
                    next: resp.data.page && resp.data.page.keyset && resp.data.page.keyset.next ? resp.data.page.keyset.next : null,
                    previous: resp.data.page && resp.data.page.keyset && resp.data.page.keyset.previous ? resp.data.page.keyset.previous : null,
                }
                let saleListData = resp?.data?.data
                let saleId = saleListData.map(elem => { return elem.id })
                let payload = { "filter": [{ "field": "saleid", "value": [saleId], "op": "IN", "join": "AND" }] };
                const saleImageApiResult = await SalesService.getSaleImagesList(payload)
                if (saleImageApiResult?.data.status?.toLowerCase() == "success") {
                    let saleImageListData = saleImageApiResult?.data?.data;

                    await saleListData.forEach(sale => {
                        let url = null;
                        let data = saleImageListData.find(elem => { return elem.saleid == sale.id });
                        if (data) {
                            let urlArr = typeof data?.saleimageurl === 'string' ? data.saleimageurl.split(',') : typeof data?.locationimageurl === 'string' ? data.locationimageurl.split(',') : [];
                            let profileUrl = urlArr.find(elem => { return elem.includes('profile') });
                            url = typeof profileUrl == 'string' && profileUrl.includes('#*#') ? profileUrl.split("#*#")[1] : new_image_thumbnail;
                        }
                        sale['saleimageurl'] = url;
                    });
                }
                setistodaySale(!(saleListData.length > 0));
                setSaleList(saleListData);
                setcontentload(false);
            }
        ).catch((error) => {
            if (error?.status === 401) {
                store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                logout(props.history, false);
            }
            setcontentload(false);
        });
    }

    const watching = (item, index) => {
        setDisableWatch(true);
        if (!isAuthorized()) {
            return
        }

        if (item?.iswatch) {
            const removeData = {
                "data": {
                    "itemIds": [item?.item_id]
                }
            };
            ItemsService.removeFromWatch(removeData).then(
                async (response) => {
                    // let ilist = [...itemList]
                    // ilist[index]["iswatch"] = false
                    // setitemList(ilist)
                    await getWatchList(itemList);
                    setDisableWatch(false);
                }
            ).catch(error => {
            });
        } else {
            const addData = {
                "data": [
                    {
                        "itemid": item?.item_id
                    }
                ]
            }
            ItemsService.addToWatch(addData).then(
                async (response) => {
                    // let ilist = [...itemList]
                    // ilist[index]["iswatch"] = true
                    // setitemList(ilist)
                    await getWatchList(itemList);
                    setDisableWatch(false);
                }
            ).catch(error => {
            });
        }

    }

    const imageNavigateToItem = (item) => {
        props.history.push({
            pathname: `/my-account/premier/auction-sneak-peak-item/${item.sale_id}/item/${item?.item_id}`, state: {
                saleId: item.sale_id,
                sale: {
                    id: item.sale_id,
                    locationid: item.loc_id
                },
                item: {
                    id: item.item_id
                }
            }
        });
    }

    const getMoreList = async (index) => {
        setcontentload(true);
        await getSaleList(index);
        const scrollContainer = document.querySelector('.scroll-content');
        if (scrollContainer) {
            scrollContainer.scrollTop = 490;
        } else {
            window.scrollTo(0, 0);
        }
    }

    if (pageLoading)
        return (<Loader />)
    return (
        <>
            <Helmet>
                <title>CTBids | Premier Auction Sneak Peek</title>
            </Helmet>
            {pageLoading ?
                <Loader /> :

                <div className="asp">
                    {props.user.suspensionstatus === "ALL" ?
                        <div className="w-100" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                            <div style={{ fontSize: '24px', fontWeight: 'bold', textAlign: 'center', width: '60%' }}>
                                You are currently suspended from bidding on CTBids. Please reach out to <a style={{ color: '#A50050' }} href="tel:(844) 4-BID-HELP" >(844) 4-BID-HELP</a> or email <a style={{ color: '#A50050' }} href="mailto:ctbidshelp@caringtransitions.com">ctbidshelp@caringtransitions.com</a> if you have any questions.
                            </div>
                        </div>
                        : <div className="asps_container w-100">
                            <div className="asp_container">
                                <div className="header">
                                    <img className="headlogo" src={sneakPeekBerry} />
                                    <div className="title">
                                        <div className="atitle">Auction Sneak Peek</div>
                                        <div className="head_cont">You are amongst the first to preview upcoming CTBids auctions.</div>
                                    </div>
                                </div>
                                <div className="itemlist">
                                    <Row xs={1} sm={1} md={2} lg={3}>
                                        {itemList?.map((item, index) => (
                                            <Col key={`items_${index}`} className=" clickable">
                                                <div className="acard-head">{naming[item?.ctype]}</div>
                                                <div className={"itemcard"}>
                                                    <div className="image-card clickable" role={"button"} onClick={() => { imageNavigateToItem(item) }}>
                                                        <div className="img-container">
                                                            <img className="items-image" src={item.image_url ? item.image_url : item.thumbnail_url ? item.thumbnail_url : new_image_thumbnail} alt="item"></img>
                                                        </div>
                                                    </div>
                                                    <div className="item_text">
                                                        <div className="item-card-title" style={{
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis"
                                                        }}>{item?.item_title}</div>
                                                        <button className={`watchbtn  ${item?.iswatch ? "watching" : ""}`} onClick={() => { watching(item, index) }} disabled={disableWatch}>
                                                            {eye}
                                                        </button>
                                                    </div>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                                <div>
                                    {istodaySale && <h5>Currently, we are crafting new and unique estate sales. <br></br>
                                        As soon as a new auction is available to preview it will be listed here.<br />
                                        With over 500 auctions each month you won't have to wait long</h5>}
                                </div>
                            </div>
                            <div className="">
                                <div className="header">
                                    {istodaySale ? <div className="left">
                                        <div className="sub-ahead">Live Auctions You Can Bid On Today</div>
                                    </div> :
                                        <div className="left">
                                            <div className="no-wrap sub-ahead">Auctions Coming Soon</div>
                                        </div>}
                                </div>
                                <div className="sub-acont">We know you're excited about upcoming auctions, we are too. Until this auction is live, we will not be able to answer any questions or provide additional information regarding these items.
                                    Auction dates and items are subject to change. Click on the auction listing below to preview their items.
                                </div>
                            </div>
                            <div className="table-container">
                                <div className="t-head">
                                    {innerWidth >= '610' ?
                                        <div className="flexview">
                                            <div className="imge-content-width"></div>
                                            <div className="auction-head">Auction Information</div>
                                            {!istodaySale && <div className="start-timehead">Tentative Start Date</div>}
                                        </div> :
                                        <div>
                                            <div className="auction-head text-center">Auction Information</div>
                                        </div>}
                                </div>
                            </div>
                            {contentload ? <div className="loader d-flex align-items-center justify-content-center">
                                <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                            </div> : <div className="table-body">
                                {saleList?.map((item, index) => (
                                    <div className="t-row"
                                        role={"button"}
                                        onClick={() => {
                                            let pusttoStore = { ...statemaintenance }
                                            delete pusttoStore["AuctionSneakPeekItems"]
                                            dispatch({
                                                type: 'PUSH_TO_STATE', payload: pusttoStore
                                            });
                                            props.history.push({
                                                pathname: `/my-account/premier/auction-sneak-peak-sale/${item?.id}`, state: {
                                                    sale: { ...item },
                                                }
                                            });
                                        }}>
                                        {innerWidth >= '610' ?
                                            <div className="flexview">
                                                {item?.saleimageurl ? <img key={`sale_image`} className="sale-image imge-content-width" src={item?.saleimageurl} alt="item - image"></img> :
                                                    <div className="sale-image imge-content-width"> <img src={new_image_thumbnail} className="defaultimg" /></div>}
                                                <div className="auction-head">
                                                    <div className="row-title">{item?.title}</div>
                                                    <div className="row-loc">Location : {item?.locationtitle}</div>
                                                </div>
                                                <div className="d-flex gap-2 align-items-center start-timehead">
                                                    {!istodaySale && <div className=""> {moment(item?.starttime).format("MMMM DD YYYY")}</div>}
                                                    {moment(item?.starttime) <= moment(new Date()) && item.status == 'Started' ?
                                                        <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>This sale is live</Tooltip>}>
                                                            <div><img src={bidBIcon} className="bidicon" alt="bid"></img></div>
                                                        </OverlayTrigger>
                                                        : null}
                                                </div>

                                            </div> :
                                            <div>
                                                <div className="flexview">
                                                    {item?.saleimageurl ? <img key={`sale_image`} className="sale-image imge-content-width" src={item?.saleimageurl} alt="item - image"></img> :
                                                        <div className="sale-image imge-content-width"> <img src={new_image_thumbnail} className="defaultimg" /></div>}
                                                    <div className="auction-cont">
                                                        <div className="row-title">{item?.title}</div>
                                                        <div className="row-loc">Location : {item?.locationtitle}</div>
                                                        {!istodaySale && <div className="row-loc" >Tentative Start Date : {moment(item?.starttime).format("MMMM DD YYYY")}  {moment(item?.starttime) <= moment(new Date()) && item.status == 'Started' ?
                                                            <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>This sale is live</Tooltip>}>
                                                                <span><img className="bidicon" src={bidBIcon} alt="bid"></img></span>
                                                            </OverlayTrigger>
                                                            : null}</div>}
                                                    </div>
                                                </div>
                                            </div>}

                                        <div className="borderui"></div>
                                    </div>
                                ))}
                            </div>}
                            {Math.ceil(pagekey.current?.total / pageSize) > 1 && <div className='btm-flex'>
                                <div>
                                    {contentload ? <img className="loader-gif" src={loaderIcon} alt="loader-icon"></img> :
                                        ` Showing ${(saleList.length + ((currentindex.current - 1) * pageSize))} of ${pagekey.current?.total} records`}
                                </div>
                                <div>
                                    <PaginationBox totalrecord={Math.ceil(pagekey.current?.total / pageSize)} onclickBox={(index) => {
                                        getMoreList(index)
                                    }} currentIndex={currentindex.current} className={"w-50"} />
                                </div>
                            </div>}
                            <div className="d-flex flex-row justify-content-center mrbt-2 sneak-item-resp py-5">
                                <img className="logobid" src={sneakpreview} />
                            </div>
                        </div>}
                </div>}</>
    )
}
class AuctionSneakPeek extends Component {
    constructor(props) {
        super(props);
        this.buyrId = this.props.user.id
    }

    render() {
        return <AuctionSneakPeekfn {...this.props} />
    }
}

export default connect(state => state)(AuctionSneakPeek);